import apiCall from '@/utils/api'

const state = {
	workflows: [],
   workflowsPagination: {
		search: ' ',
		current_page: 1,
		per_page: 0,
	    total: 0,
	    visible: 10
	},
   workflowsLoader: false
};

const getters = {
   workflowsLoader: (state) => state.workflowsLoader,
	workflows: (state) => state.workflows,
   workflowsPagination: (state) => state.workflowsPagination
}

const actions = {
    async fetchworkflows({commit}, page = '') {
        if (page !== '') {
            const response = await apiCall({url: `/api/workflow?page=${page}`, method: 'GET'});
            commit('setworkflows', response)
            commit('stopLoader', response)
        } else {
            const response = await apiCall({url: `/api/workflow`, method: 'GET'});
            commit('setworkflows', response)
        }
	},
    async filterworkflows({commit, state},resp){
		commit('setworkflows', resp)
	},
	async startworkflowsLoader({commit, state},resp){
		commit('startLoader', resp)
	},
	async stopworkflowsLoader({commit, state},resp){
		commit('stopLoader', resp)
	},
};

const mutations = {
	setworkflows: (state, workflows) => {
		state.workflows = workflows.data
		state.workflowsPagination.current_page = workflows.current_page
		state.workflowsPagination.total = workflows.total
		state.workflowsPagination.per_page = workflows.per_page
	},
    startLoader: (state) => state.workflowsLoader = true,
	stopLoader: (state) => state.workflowsLoader = false,
};

export default {
	state,
	getters,
	actions,
	mutations
}
